// extracted by mini-css-extract-plugin
export default {"fastAccessWrap":"index_fastAccessWrap__Sz4ht","fastAccessWrapContent":"index_fastAccessWrapContent__W1S1s"};